import { render, staticRenderFns } from "./JobProgress.vue?vue&type=template&id=36705bee&scoped=true"
import script from "./JobProgress.vue?vue&type=script&lang=js"
export * from "./JobProgress.vue?vue&type=script&lang=js"
import style0 from "./JobProgress.vue?vue&type=style&index=0&id=36705bee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36705bee",
  null
  
)

export default component.exports